module.exports = __webpack_public_path__ + "img/big_1_15.59da61ff.png";